import React from 'react';
import propTypes from 'prop-types';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null, errorInfo: null, hasError: false};
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
            hasError: true,
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={" py-10"}>
                    <h2 className="text-6xl font-['Poppins-Bold'] text-center mt-12">Oops!...</h2>
                    <p className="text-center text-lg md:text-2xl mt-12">Something went
                        wrong. Please refresh page</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
    children: propTypes.any,
}